import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/api/auth/login',
    method: 'post',
    data
  })
}

export function register(data) {
  return request({
    url: '/api/auth/register',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: '/api/auth/logout',
    method: 'post'
  })
}

export function getUserProfile() {
  return request({
    url: '/api/user/profile',
    method: 'get'
  })
}

export function updateUserProfile(data) {
  return request({
    url: '/api/user/profile',
    method: 'put',
    data
  })
}

/**
 * 上传用户头像
 * @param {File} file - 头像文件
 */
export function uploadUserAvatar(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/api/upload/single',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 修改当前用户密码
 * @param {Object} data - oldPassword/newPassword
 */
export function updateUserPassword(data) {
  return request({
    url: '/api/user/password',
    method: 'put',
    data
  })
}

/**
 * 获取用户列表（管理员）
 * @param {Object} params - 查询参数
 */
export function getAdminUserList(params) {
  return request({
    url: '/api/admin/user/list',
    method: 'get',
    params
  })
}

/**
 * 更新用户信息（管理员）
 * @param {Number} userId - 用户ID
 * @param {Object} data - 更新数据
 */
export function updateAdminUser(userId, data) {
  return request({
    url: `/api/admin/user/${userId}`,
    method: 'put',
    data
  })
}

/**
 * 删除用户（管理员）
 * @param {Number} userId - 用户ID
 */
export function deleteAdminUser(userId) {
  return request({
    url: `/api/admin/user/${userId}`,
    method: 'delete'
  })
}
